import React from 'react';
import { Box, styled } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useConfig } from '../../Hooks/useConfig';

const BannerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSidebarOpen',
})(({ theme, isSidebarOpen }) => ({
  // width: '93.3vw',
  width: 'calc(100% - 115px)',

  marginLeft: 'auto',
  marginRight: '10px',
  // marginTop: '16px',
  borderRadius: '16px',
  // marginBottom: '-28px',
  cursor: 'pointer',
  display: 'block',
  overflow: 'hidden',
  '&:hover': {
    opacity: 0.95,
  },
  transition: 'width 0.3s ease, opacity 0.2s ease',
  height: 'auto',
  // Fixed heights for consistent sidebar spacing
  // [theme.breakpoints.up('lg')]: {
  //   height: '71px', // Desktop
  // },
  // [theme.breakpoints.between('md', 'lg')]: {
  //   height: '64.27px', // Tablet
  // },
  // [theme.breakpoints.down('md')]: {
  //   height: 'auto', // Mobile - keep responsive
  // },

  [theme.breakpoints.down('md')]: {
    width: 'calc(100% - 21px)',
  },

  [theme.breakpoints.up('md')]: {
    width: isSidebarOpen ? 'calc(100% - 276px)' : 'calc(100% - 115px)',
  },
}));

const BannerImage = styled('img')(({ theme }) => ({
  width: '100%',
  display: 'block',

  // Fixed height with object-fit for desktop and tablet
  [theme.breakpoints.up('md')]: {
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },

  // Auto height for mobile
  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
}));

const ChristmasBanner = ({ isSidebarOpen }) => {
  const history = useHistory();

  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];
  const isPanel = subdomain.includes('panel');
  const { panelUrl, playgroundUrl } = useConfig();

  const handleClick = () => {
    if (isPanel) {
      history.push('/billing/pricing');
    } else {
      window.location.href = `${panelUrl}/billing/pricing`;
    }
  };

  return (
    <BannerContainer onClick={handleClick} isSidebarOpen={isSidebarOpen}>
      {/* Desktop image - shown on large screens (≥1200px) */}
      <BannerImage
        src="/static/img/banners/banner-christmas-desktop.jpg"
        alt="Christmas Offer - Monthly 20% OFF"
        sx={{
          display: { xs: 'none', md: 'none', lg: 'block' },
        }}
      />

      {/* Tablet image - shown on medium screens (900px-1200px) */}
      <BannerImage
        src="/static/img/banners/banner-christmas-tablet.jpg"
        alt="Christmas Offer - Monthly 20% OFF"
        sx={{
          display: { xs: 'none', md: 'block', lg: 'none' },
        }}
      />

      {/* Mobile image - shown on small screens (<900px) */}
      <BannerImage
        src="/static/img/banners/banner-christmas-mobile.jpg"
        alt="Christmas Offer - Monthly 20% OFF"
        sx={{
          display: { xs: 'block', md: 'none' },
        }}
      />
    </BannerContainer>
  );
};

export default ChristmasBanner;
